import "./Roi.css";
import { useMemo, useState } from "react";

/* =========================================================
   MOCK DATA
========================================================= */

const mockMultiBets = [
  {
    instance: "INS-001",
    total_odds: 8.5,
    multi_stake: 100,
    status: "won",
  },
  {
    instance: "INS-002",
    total_odds: 12.4,
    multi_stake: 100,
    status: "lost",
  },
  {
    instance: "INS-003",
    total_odds: 6.8,
    multi_stake: 100,
    status: "won",
  },
  {
    instance: "INS-004",
    total_odds: 15.2,
    multi_stake: 100,
    status: "lost",
  },
  {
    instance: "INS-005",
    total_odds: 9.1,
    multi_stake: 100,
    status: "won",
  },
];

const mockIndividualBets = [
  {
    instance: "INS-001",
    team: "Arsenal",
    prediction: "Home",
    odd: 1.8,
    stake: 100,
    status: "won",
  },
  {
    instance: "INS-001",
    team: "Chelsea",
    prediction: "Away",
    odd: 2.1,
    stake: 100,
    status: "lost",
  },
  {
    instance: "INS-001",
    team: "Barcelona",
    prediction: "Home",
    odd: 1.6,
    stake: 100,
    status: "won",
  },
  {
    instance: "INS-001",
    team: "Inter Milan",
    prediction: "Home",
    odd: 1.9,
    stake: 100,
    status: "won",
  },
  {
    instance: "INS-001",
    team: "Real Madrid",
    prediction: "Away",
    odd: 2.0,
    stake: 100,
    status: "won",
  },
  {
    instance: "INS-001",
    team: "Liverpool",
    prediction: "Home",
    odd: 1.7,
    stake: 100,
    status: "won",
  },
  {
    instance: "INS-001",
    team: "Bayern",
    prediction: "Home",
    odd: 1.5,
    stake: 100,
    status: "won",
  },

  {
    instance: "INS-002",
    team: "Man City",
    prediction: "Home",
    odd: 1.5,
    stake: 100,
    status: "won",
  },
  {
    instance: "INS-002",
    team: "PSG",
    prediction: "Home",
    odd: 1.8,
    stake: 100,
    status: "won",
  },
  {
    instance: "INS-002",
    team: "Juventus",
    prediction: "Away",
    odd: 2.2,
    stake: 100,
    status: "lost",
  },
  {
    instance: "INS-002",
    team: "AC Milan",
    prediction: "Home",
    odd: 1.9,
    stake: 100,
    status: "won",
  },
  {
    instance: "INS-002",
    team: "Dortmund",
    prediction: "Home",
    odd: 1.7,
    stake: 100,
    status: "won",
  },
  {
    instance: "INS-002",
    team: "Napoli",
    prediction: "Away",
    odd: 2.0,
    stake: 100,
    status: "won",
  },
  {
    instance: "INS-002",
    team: "Ajax",
    prediction: "Home",
    odd: 1.6,
    stake: 100,
    status: "won",
  },

  {
    instance: "INS-003",
    team: "PSV",
    prediction: "Home",
    odd: 1.7,
    stake: 100,
    status: "won",
  },
  {
    instance: "INS-003",
    team: "Porto",
    prediction: "Home",
    odd: 1.8,
    stake: 100,
    status: "won",
  },
  {
    instance: "INS-003",
    team: "Benfica",
    prediction: "Away",
    odd: 2.0,
    stake: 100,
    status: "won",
  },
  {
    instance: "INS-003",
    team: "Lyon",
    prediction: "Home",
    odd: 1.9,
    stake: 100,
    status: "won",
  },
  {
    instance: "INS-003",
    team: "Roma",
    prediction: "Home",
    odd: 1.6,
    stake: 100,
    status: "won",
  },
  {
    instance: "INS-003",
    team: "Napoli",
    prediction: "Home",
    odd: 1.7,
    stake: 100,
    status: "won",
  },
  {
    instance: "INS-003",
    team: "Ajax",
    prediction: "Away",
    odd: 1.8,
    stake: 100,
    status: "won",
  },
];

/* =========================================================
   HELPERS
========================================================= */

const money = (value) => `${Number(value).toLocaleString()} KSh`;

const percentage = (value) => `${Number(value).toFixed(2)}%`;

/* =========================================================
   ROI CALCULATIONS
========================================================= */

function calculateMultiBetROI(bets) {
  let totalStake = 0;
  let totalReturn = 0;

  const results = bets.map((bet) => {
    const stake = Number(bet.multi_stake) || 0;
    const odds = Number(bet.total_odds) || 0;

    totalStake += stake;

    const won = bet.status === "won";

    const returned = won ? stake * odds : 0;

    totalReturn += returned;

    const profit = returned - stake;

    return {
      ...bet,
      returned,
      profit,
    };
  });

  const profit = totalReturn - totalStake;

  const roi = totalStake ? (profit / totalStake) * 100 : 0;

  return {
    results,
    totalStake,
    totalReturn,
    profit,
    roi,
  };
}

function calculateIndividualROI(bets) {
  let totalStake = 0;
  let totalReturn = 0;

  const results = bets.map((bet) => {
    const stake = Number(bet.stake) || 0;
    const odd = Number(bet.odd) || 0;

    totalStake += stake;

    const won = bet.status === "won";

    const returned = won ? stake * odd : 0;

    totalReturn += returned;

    const profit = returned - stake;

    return {
      ...bet,
      returned,
      profit,
    };
  });

  const profit = totalReturn - totalStake;

  const roi = totalStake ? (profit / totalStake) * 100 : 0;

  return {
    results,
    totalStake,
    totalReturn,
    profit,
    roi,
  };
}

/* =========================================================
   COMPONENT
========================================================= */

export default function Roi() {
  const [activeTab, setActiveTab] = useState("overview");

  const multiROI = useMemo(() => calculateMultiBetROI(mockMultiBets), []);

  const individualROI = useMemo(
    () => calculateIndividualROI(mockIndividualBets),
    [],
  );

  /* Combined */
  const combinedStake = multiROI.totalStake + individualROI.totalStake;

  const combinedReturn = multiROI.totalReturn + individualROI.totalReturn;

  const combinedProfit = combinedReturn - combinedStake;

  const combinedROI = combinedStake
    ? (combinedProfit / combinedStake) * 100
    : 0;

  return (
    <div className="alg1_card roi_main">
      {/* =====================================================
          HEADER
      ===================================================== */}

      <header className="roi_header">
        <div>
          <span className="roi_eyebrow">PERFORMANCE ANALYTICS</span>

          <h1>ROI Dashboard</h1>

          <p>
            Track individual bets, multi-bets and overall betting performance.
          </p>
        </div>

        <div className="roi_header_status">
          <span></span>
          Mock Data
        </div>
      </header>

      {/* =====================================================
          NAVIGATION
      ===================================================== */}

      <nav className="roi_nav">
        <button
          className={activeTab === "overview" ? "active" : ""}
          onClick={() => setActiveTab("overview")}
        >
          Overview
        </button>

        <button
          className={activeTab === "multi" ? "active" : ""}
          onClick={() => setActiveTab("multi")}
        >
          Multi Bets
        </button>

        <button
          className={activeTab === "individual" ? "active" : ""}
          onClick={() => setActiveTab("individual")}
        >
          Individual Bets
        </button>
      </nav>

      {/* =====================================================
          CONTENT
      ===================================================== */}

      <main className="roi_content">
        {/* ===================================================
            OVERVIEW
        =================================================== */}

        {activeTab === "overview" && (
          <>
            <section className="roi_stats">
              <div className="roi_stat_card">
                <span>Total Stake</span>
                <strong>{money(combinedStake)}</strong>
              </div>

              <div className="roi_stat_card">
                <span>Total Return</span>
                <strong>{money(combinedReturn)}</strong>
              </div>

              <div className="roi_stat_card">
                <span>Total Profit</span>
                <strong className={combinedProfit >= 0 ? "profit" : "loss"}>
                  {combinedProfit >= 0 ? "+" : ""}
                  {money(combinedProfit)}
                </strong>
              </div>

              <div className="roi_stat_card">
                <span>ROI</span>
                <strong className={combinedROI >= 0 ? "profit" : "loss"}>
                  {combinedROI >= 0 ? "+" : ""}
                  {percentage(combinedROI)}
                </strong>
              </div>
            </section>

            {/* =================================================
                PERFORMANCE SPLIT
            ================================================= */}

            <section className="roi_two_columns">
              <div className="roi_panel">
                <div className="roi_panel_header">
                  <div>
                    <h2>Multi-Bet Performance</h2>
                    <span>Accumulator results</span>
                  </div>

                  <strong className={multiROI.profit >= 0 ? "profit" : "loss"}>
                    {percentage(multiROI.roi)}
                  </strong>
                </div>

                <div className="roi_metric_rows">
                  <div>
                    <span>Instances</span>
                    <strong>{multiROI.results.length}</strong>
                  </div>

                  <div>
                    <span>Stake</span>
                    <strong>{money(multiROI.totalStake)}</strong>
                  </div>

                  <div>
                    <span>Return</span>
                    <strong>{money(multiROI.totalReturn)}</strong>
                  </div>

                  <div>
                    <span>Profit</span>
                    <strong
                      className={multiROI.profit >= 0 ? "profit" : "loss"}
                    >
                      {money(multiROI.profit)}
                    </strong>
                  </div>
                </div>
              </div>

              <div className="roi_panel">
                <div className="roi_panel_header">
                  <div>
                    <h2>Individual Performance</h2>
                    <span>Single-match results</span>
                  </div>

                  <strong
                    className={individualROI.profit >= 0 ? "profit" : "loss"}
                  >
                    {percentage(individualROI.roi)}
                  </strong>
                </div>

                <div className="roi_metric_rows">
                  <div>
                    <span>Bets</span>
                    <strong>{individualROI.results.length}</strong>
                  </div>

                  <div>
                    <span>Stake</span>
                    <strong>{money(individualROI.totalStake)}</strong>
                  </div>

                  <div>
                    <span>Return</span>
                    <strong>{money(individualROI.totalReturn)}</strong>
                  </div>

                  <div>
                    <span>Profit</span>
                    <strong
                      className={individualROI.profit >= 0 ? "profit" : "loss"}
                    >
                      {money(individualROI.profit)}
                    </strong>
                  </div>
                </div>
              </div>
            </section>

            {/* =================================================
                SIMPLE ROI VISUAL
            ================================================= */}

            <section className="roi_panel">
              <div className="roi_panel_header">
                <div>
                  <h2>ROI Performance</h2>
                  <span>Current return on total stake</span>
                </div>

                <strong className={combinedROI >= 0 ? "profit" : "loss"}>
                  {percentage(combinedROI)}
                </strong>
              </div>

              <div className="roi_progress">
                <div
                  className={
                    combinedROI >= 0
                      ? "roi_progress_bar positive"
                      : "roi_progress_bar negative"
                  }
                  style={{
                    width: `${Math.min(Math.abs(combinedROI), 100)}%`,
                  }}
                />
              </div>

              <div className="roi_progress_labels">
                <span>Loss</span>
                <span>Break-even</span>
                <span>Profit</span>
              </div>
            </section>
          </>
        )}

        {/* ===================================================
            MULTI BET TABLE
        =================================================== */}

        {activeTab === "multi" && (
          <section className="roi_panel">
            <div className="roi_panel_header">
              <div>
                <h2>Multi-Bet Results</h2>

                <span>Each instance is treated as one accumulator.</span>
              </div>

              <strong className={multiROI.profit >= 0 ? "profit" : "loss"}>
                ROI {percentage(multiROI.roi)}
              </strong>
            </div>

            <div className="roi_table_wrapper">
              <table className="roi_table">
                <thead>
                  <tr>
                    <th>Instance</th>
                    <th>Total Odds</th>
                    <th>Stake</th>
                    <th>Status</th>
                    <th>Return</th>
                    <th>Profit / Loss</th>
                  </tr>
                </thead>

                <tbody>
                  {multiROI.results.map((bet) => (
                    <tr key={bet.instance}>
                      <td>
                        <strong>{bet.instance}</strong>
                      </td>

                      <td>{bet.total_odds}</td>

                      <td>{money(bet.multi_stake)}</td>

                      <td>
                        <span className={`bet_status ${bet.status}`}>
                          {bet.status}
                        </span>
                      </td>

                      <td>{money(bet.returned)}</td>

                      <td className={bet.profit >= 0 ? "profit" : "loss"}>
                        {bet.profit >= 0 ? "+" : ""}
                        {money(bet.profit)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        )}

        {/* ===================================================
            INDIVIDUAL TABLE
        =================================================== */}

        {activeTab === "individual" && (
          <section className="roi_panel">
            <div className="roi_panel_header">
              <div>
                <h2>Individual Bets</h2>

                <span>Individual selection performance.</span>
              </div>

              <strong className={individualROI.profit >= 0 ? "profit" : "loss"}>
                ROI {percentage(individualROI.roi)}
              </strong>
            </div>

            <div className="roi_table_wrapper">
              <table className="roi_table">
                <thead>
                  <tr>
                    <th>Instance</th>
                    <th>Team</th>
                    <th>Prediction</th>
                    <th>Odd</th>
                    <th>Stake</th>
                    <th>Status</th>
                    <th>Return</th>
                    <th>Profit / Loss</th>
                  </tr>
                </thead>

                <tbody>
                  {individualROI.results.map((bet, index) => (
                    <tr key={`${bet.instance}-${index}`}>
                      <td>{bet.instance}</td>

                      <td>
                        <strong>{bet.team}</strong>
                      </td>

                      <td>{bet.prediction}</td>

                      <td>{bet.odd}</td>

                      <td>{money(bet.stake)}</td>

                      <td>
                        <span className={`bet_status ${bet.status}`}>
                          {bet.status}
                        </span>
                      </td>

                      <td>{money(bet.returned)}</td>

                      <td className={bet.profit >= 0 ? "profit" : "loss"}>
                        {bet.profit >= 0 ? "+" : ""}
                        {money(bet.profit)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        )}
      </main>
    </div>
  );
}
